import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { AcceptanceTermsFilterRequest } from '../models/request';
import { IAcceptanceTermsApi } from './base';
import { TimeoutRequestConfigurationEnum } from '../services/enum/TimeoutRequestConfigurationEnum';

const baseRoute: string = 'AcceptanceTerms';

export class AcceptanceTermsApi extends IAcceptanceTermsApi {
  save(
    request: AcceptanceTermsFilterRequest
  ): Promise<AxiosResponse<Result<void>, any>> {
    return api.post(`${baseRoute}`, request, {
      timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds
    });
  }
}
